import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  locale: string;
}

function FlagButton({ locale }: Props) {
  const { i18n } = useTranslation();

  function handleChangeLocale() {
    i18n.changeLanguage(locale)
  }
  
  return (
    <IconButton onClick={handleChangeLocale}>
      <img
        loading="lazy"
        width="20"
        srcSet={`https://flagcdn.com/w40/${locale.toLowerCase()}.png 2x`}
        src={`https://flagcdn.com/w20/${locale.toLowerCase()}.png`}
        alt=""
      />
    </IconButton>
  )
}

export default FlagButton;